import React, { useEffect } from "react";
import Hero from "@/components/site/Hero";
import MissionStatement from "@/components/site/MissionStatement";
import DoctrinePillars from "@/components/site/DoctrinePillars";
import Sentinel22 from "@/components/site/Sentinel22";
import WhoWeServe from "@/components/site/WhoWeServe";
import WhyMSWDC from "@/components/site/WhyMSWDC";
import CTABand from "@/components/site/CTABand";

export default function HomePage() {
  useEffect(() => {
    document.title = "MSWDC · Midnight Sun Working Dog Coalition";
  }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <MissionStatement />
      <DoctrinePillars />
      <Sentinel22 />
      <WhoWeServe />
      <WhyMSWDC />
      <CTABand />
    </main>
  );
}
